import React from 'react';

export const ChevronDown = ({
  color,
  height,
  width,
  ...rest
}: {
  color?: string;
  height?: string;
  width?: string;
  [key: string]: string | number | undefined;
}): JSX.Element => {
  const className = 'icon icon--chevron-down';
  color = color || '#0076CC';
  width = width || '16';
  height = height || '9';
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className, ...rest }}
    >
      <path
        d="M15 1L8 8L1 1"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronDown;
